/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NeeDocumentsData from './NeeDocumentsData';
import NeeDocumentsStatus from './NeeDocumentsStatus';

/**
 * The NeeDocuments model module.
 * @module model/NeeDocuments
 * @version 1.0.0
 */
class NeeDocuments {
    /**
     * Constructs a new <code>NeeDocuments</code>.
     * @alias module:model/NeeDocuments
     */
    constructor() { 
        
        NeeDocuments.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NeeDocuments</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NeeDocuments} obj Optional instance to populate.
     * @return {module:model/NeeDocuments} The populated <code>NeeDocuments</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NeeDocuments();

            if (data.hasOwnProperty('status')) {
                obj['status'] = NeeDocumentsStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('data')) {
                obj['data'] = NeeDocumentsData.constructFromObject(data['data']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/NeeDocumentsStatus} status
 */
NeeDocuments.prototype['status'] = undefined;

/**
 * @member {module:model/NeeDocumentsData} data
 */
NeeDocuments.prototype['data'] = undefined;






export default NeeDocuments;

